export const GETTWINRAPPORT = "GETTWINRAPPORT"
export const ADD_RAPPORT_TWIN_SUCCESS ="ADD_RAPPORT_TWIN_SUCCESS"
export const ADD_RAPPORT_TWIN_FAILURE ="ADD_RAPPORT_TWIN_FAILURE "